import React, { useState, useContext, useEffect } from "react";
import { useHistory, useParams, useLocation } from "react-router-dom";

//pages & includes
import ManageSidebar from "../ManageSidebar";

//functions
import {
  _t,
  getCookie,
  tableLoading,
  customStyle,
} from "../../../../../functions/Functions";
import { useTranslation } from "react-i18next";

//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../../BaseUrl";
import Select from "react-select";
//3rd party packages
import { Helmet } from "react-helmet";
import "react-confirm-alert/src/react-confirm-alert.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

//context consumer
import { RestaurantContext } from "../../../../../contexts/Restaurant";
import { FoodContext } from "../../../../../contexts/Food";
import { useMemo } from "react";

const IngredientLimitAction = () => {
  const { t } = useTranslation();
  const history = useHistory();

  let {
    loading,
    setLoading,
    //item limit
    branchForSearch,
    ingredientItemForSearch,

  } = useContext(RestaurantContext);

  const { foodForPOS } = useContext(FoodContext);

  const { search } = useLocation();

  const { id } = useParams()

  const [newIngredientLimit, setNewIngredientLimit] = useState({
    edit: false,
    id: null,
    branch: null,
    items: {}, // Changed to Object for O(1) updates
    type: 'igs' // 'igs' or 'fgs'
  })

  const [searchTerm, setSearchTerm] = useState("");

  //set edit true & values
  const handleSetEdit = async () => {
    try {
      const url = `${BASE_URL}/settings/ingredient-limit/${id}${search}`;
      const response = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      const ingredientItemLimit = response.data;
      const branch = {
        id: ingredientItemLimit[0].branch_id,
        name: ingredientItemLimit[0].branch_name,
      }

      const itemsObj = {};
      ingredientItemLimit.forEach(item => {
        itemsObj[item.ingredient_item_id] = {
          ingredient_item_id: item.ingredient_item_id,
          ingredient_item_name: item.ingredient_item_name,
          min_limit: item.min_limit,
          max_limit: item.max_limit
        };
      });

      setNewIngredientLimit({
        ...newIngredientLimit,
        id: parseInt(id),
        branch: branch,
        items: itemsObj,
        edit: true,
        type: ingredientItemLimit[0].type || 'igs'
      });
    } catch (err) {
      toast.error("please try again", {
        position: "bottom-center",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      })
    }

  };

  useEffect(() => {

    if (id) {
      handleSetEdit()
    }

  }, [id])

  const initializeBranchItems = (branch, type) => {
    const itemSource = (type === 'igs') ? ingredientItemForSearch : foodForPOS;
    const itemsObj = {};
    if (itemSource) {
      itemSource.forEach((item) => {
        const { id, name } = item;
        itemsObj[id] = {
          ingredient_item_id: id,
          ingredient_item_name: name,
          min_limit: 0,
          max_limit: 0,
        };
      });
    }

    setNewIngredientLimit(prev => ({
      ...prev,
      branch: branch,
      items: itemsObj
    }));
  }

  const currentItemSource = useMemo(() => {
    return Object.values(newIngredientLimit.items || {});
  }, [newIngredientLimit.items]);

  const filteredItems = useMemo(() => {
    return currentItemSource.filter(item =>
      item.ingredient_item_name && (item.ingredient_item_name.toLowerCase().includes(searchTerm.toLowerCase()))
    );
  }, [currentItemSource, searchTerm]);

  const handleTypeChange = (type) => {
    setNewIngredientLimit({
      ...newIngredientLimit,
      type: type,
      branch: null,
      items: {}
    });
    setSearchTerm("");
  }

  const handleSetBranch = (branch) => {
    if (!newIngredientLimit.edit) {
      initializeBranchItems(branch, newIngredientLimit.type);
    } else {
      setNewIngredientLimit({
        ...newIngredientLimit,
        branch: branch,
      });
    }
  }

  const handleQty = (e, itemId) => {
    const { name, value } = e.target;
    setNewIngredientLimit(prev => ({
      ...prev,
      items: {
        ...prev.items,
        [itemId]: {
          ...prev.items[itemId],
          [name]: value
        }
      }
    }));
  }

  const handleSaveNewLimit = (e) => {
    e.preventDefault();
    const endpoint = id ? ("/settings/ingredient-limit/" + id) : "/settings/ingredient-limit"
    const limithUrl = BASE_URL + endpoint;

    const itemsArray = Object.values(newIngredientLimit.items).filter(item => item?.min_limit || (Number(item?.max_limit) > 0));

    if(!itemsArray?.length) {
      toast.error(`${_t(t("Please set at least one limit"))}`, {
        position: "bottom-center",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
      return;
    }
    const formData = {
      id: id ?? "",
      branch_id: newIngredientLimit.branch.id,
      branch_name: newIngredientLimit.branch.name,
      type: newIngredientLimit.type,
      items: itemsArray,
    }
    const method = id ? "put" : "post";
    setLoading(true);
    return axios[method](limithUrl, formData, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      }).then((res) => {

        setNewIngredientLimit({
          edit: false,
          id: null,
          branch: null,
          type: 'igs',
          items: null,
        });

        setLoading(false);
        if (id) {
          toast.success(`${_t(t("Ingredient Limit has been updated"))}`, {
            position: "bottom-center",
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            className: "text-center toast-notification",
          });
        } else {
          toast.success(`${_t(t("Ingredient Limit has been added"))}`, {
            position: "bottom-center",
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            className: "text-center toast-notification",
          });
        }

        history.push("/dashboard/manage/stock/ingredient-limit");
      })
      .catch((error) => {
        setLoading(false);
        if (error.response?.data && error.response?.data?.error === "error") {
          toast.error(`${_t(t(error.response.data.error.message))}`, {
            position: "bottom-center",
            autoClose: 10000,
            hideProgressBar: false,
            pauseOnHover: true,
            className: "text-center toast-notification",
          });
          return
        }
        toast.error(`${_t(t("Please try again"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      });
  }


  return (
    <>
      <Helmet>
        <title>{_t(t("Ingredient limit"))}</title>
      </Helmet>

      {/* Add modal */}
      {/* Add modal Ends*/}

      {/* main body */}
      <main id="main" data-simplebar>
        <div className="container-fluid">
          <div className="row t-mt-10 gx-2">
            {/* left Sidebar */}
            <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
              <ManageSidebar />
            </div>
            {/* left Sidebar ends */}

            {/* Rightbar contents */}
            <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
              <div className="t-bg-white">
                <div className="fk-scroll--pos-menu" data-simplebar>
                  <div className="t-pl-15 t-pr-15">
                    {/* Loading effect */}
                    {loading === true ? (
                      tableLoading()
                    ) : (
                      <div key="fragment3">
                        {/* next page data spin loading */}
                        {/* <div className={`${dataPaginating && "loading"}`}></div> */}
                        {/* spin loading ends */}

                        <div className="row gx-2 align-items-center t-pt-15 t-pb-15">
                          <div className="col-md-6 col-lg-5 t-mb-15 mb-md-0">
                            <ul className="t-list fk-breadcrumb">
                              <li className="fk-breadcrumb__list">
                                <span className="t-link fk-breadcrumb__link text-capitalize">
                                  {!newIngredientLimit.edit
                                    ? _t(t("Add new ingredient limit"))
                                    : _t(t("Update ingredient limit"))}
                                </span>
                              </li>
                            </ul>
                          </div>
                          <div className="col-md-6 col-lg-7">
                            <div className="row gx-3 align-items-center">
                            </div>
                          </div>
                        </div>
                        {/* form start here */}
                        <div key="fragment-branch-1">
                          <form
                            onSubmit={handleSaveNewLimit}
                            className="row card p-2 mx-3 mb-5 new-text-style"
                            autoComplete="off"
                          >
                            <div className="row mt-2">
                              <div className="col-6">
                                <label className="form-label">{_t(t("Limit Type"))}</label>
                                <div className="d-flex gap-4 mt-2">
                                  <div className="form-check custom-radio mr-3">
                                    <input
                                      className="form-check-input"
                                      type="radio"
                                      name="limitType"
                                      id="ingredient"
                                      checked={newIngredientLimit.type === 'igs'}
                                      onChange={() => handleTypeChange('igs')}
                                      disabled={newIngredientLimit.edit}
                                    />
                                    <label className="form-check-label t-link" htmlFor="ingredient">
                                      {_t(t("Ingredient Item"))}
                                    </label>
                                  </div>
                                  <div className="form-check custom-radio">
                                    <input
                                      className="form-check-input"
                                      type="radio"
                                      name="limitType"
                                      id="food"
                                      checked={newIngredientLimit.type === 'fgs'}
                                      onChange={() => handleTypeChange('fgs')}
                                      disabled={newIngredientLimit.edit}
                                    />
                                    <label className="form-check-label t-link" htmlFor="food">
                                      {_t(t("Finish Good"))}
                                    </label>
                                  </div>
                                </div>
                              </div>
                              <div className="form-group col-4">
                                <label htmlFor="name" className="form-label">
                                  {_t(t("Branch"))}{" "}
                                  <span className="text-danger">*</span>
                                </label>
                                <Select
                                  value={newIngredientLimit.branch}
                                  options={branchForSearch ? branchForSearch : []}
                                  getOptionLabel={(option) => option.name}
                                  getOptionValue={(option) => option.id}
                                  className="basic-multi-select table-text"
                                  classNamePrefix="select"
                                  isDisabled={newIngredientLimit.edit}
                                  styles={customStyle}
                                  onChange={handleSetBranch}
                                />
                              </div>
                            </div>

                            {newIngredientLimit.branch && (
                              <div className="row mt-3">
                                <div className="col-12">
                                  <div className="input-group pr-1">
                                    <span className="input-group-text bg-white border-end-0">
                                      <i className="fa fa-search text-muted"></i>
                                    </span>
                                    <input
                                      type="text"
                                      className="form-control table-text border-start-0 ps-0"
                                      placeholder={_t(t("Search items..."))}
                                      value={searchTerm}
                                      onChange={(e) => setSearchTerm(e.target.value)}
                                    />
                                  </div>
                                </div>
                              </div>
                            )}

                            <div className="row">
                              <div className="form-group mt-2 col-12">
                                <div className="table-responsive mt-2 pr-1" style={{ maxHeight: "calc(100vh - 26rem)", overflow: "auto" }}>
                                  <table className="table table-bordered-sm table-hover sticky-table-header">
                                    <thead className="align-middle">
                                      <tr>
                                        <th
                                          className="text-capitalize align-middle text-center border border-1"
                                        >
                                          {_t(t("Item Name"))}
                                        </th>
                                        <th
                                          className="text-capitalize align-middle text-center border border-1"
                                        >
                                          {_t(t("Min Limit (Purchase Qty)"))}
                                        </th>
                                        <th
                                          className="text-capitalize align-middle text-center border border-1"
                                        >
                                          {_t(t("Max Limit (Purchase Qty)"))}
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody className="align-middle">
                                      {
                                        filteredItems.length > 0 ? filteredItems.map((item) => {
                                          return (
                                            <tr key={item.ingredient_item_id}>
                                              <td
                                                className="table-text text-capitalize align-middle text-center"
                                              >
                                                {item.ingredient_item_name}
                                              </td>
                                              <td
                                                className="table-text text-capitalize align-middle text-center"
                                              >
                                                <input
                                                  className="form-control rounded-sm text-center"
                                                  type="number"
                                                  onKeyDown={(evt) =>
                                                    ["e", "E", "+", "-", "ArrowUp", "ArrowDown",].includes(evt.key) &&
                                                    evt.preventDefault()
                                                  }
                                                  onWheel={(e) => e.target.blur()}
                                                  name="min_limit"
                                                  value={item?.min_limit ?? ""}
                                                  placeholder="Min limit"
                                                  onChange={(e) => handleQty(e, item.ingredient_item_id)}
                                                />
                                              </td>
                                              <td
                                                className="table-text text-capitalize align-middle text-center"
                                              >
                                                <input
                                                  className="form-control rounded-sm text-center"
                                                  type="number"
                                                  onKeyDown={(evt) =>
                                                    ["e", "E", "+", "-", "ArrowUp", "ArrowDown",].includes(evt.key) &&
                                                    evt.preventDefault()
                                                  }
                                                  onWheel={(e) => e.target.blur()}
                                                  name="max_limit"
                                                  placeholder="Max limit"
                                                  value={item?.max_limit ?? ""}
                                                  onChange={(e) => handleQty(e, item.ingredient_item_id)}
                                                />
                                              </td>
                                            </tr>
                                          )
                                        }) : (
                                          <tr>
                                            <td colSpan="3" className="text-center p-4 text-muted">
                                              {_t(t("No items found"))}
                                            </td>
                                          </tr>
                                        )
                                      }
                                    </tbody>
                                  </table>
                                </div>
                              </div>

                            </div>

                            <div className="row mt-4">
                              <div className="d-flex justify-content-end">
                                <div className="col-3 d-flex justify-content-end">
                                  <button
                                    type="button"
                                    className="btn rounded hov-btn mr-3"
                                    onClick={() => (history.push("/dashboard/manage/stock/ingredient-limit"))}
                                  >
                                    <i className="fa fa-arrow-left" aria-hidden="true"></i> {_t(t("Back"))}
                                  </button>
                                  <button
                                    type="submit"
                                    className="btn btn-primary rounded"
                                  >
                                    <i className="fa fa-floppy-o" aria-hidden="true"></i> {!newIngredientLimit.edit ? _t(t("Save")) : _t(t("Update"))}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {/* Rightbar contents end*/}
          </div>
        </div>
      </main>
      {/* main body ends */}
    </>
  )
}

export default IngredientLimitAction
